import { Box, IconButton, Popover, Stack, Typography } from "@mui/material";
import BorderColorIcon from '@mui/icons-material/BorderColor';
import DescriptionIcon from '@mui/icons-material/Description';
import AutoFixNormalIcon from '@mui/icons-material/AutoFixNormal';
import { useMemo, useState } from "react";
import Tooltip from '@mui/material/Tooltip';
import AIIcon from "../../../../../assets/svgs/AI-Icon.svg";

const QuestionLabel = ({
    children,
    handleAddHighlight,
    accessor,
    allFields,
    aiEnabled = false,
    autoFillEnabled = false,
    autoFillInfo = null,
}) => {
    const [autoFillAnchorEl, setAutoFillAnchorEl] = useState(null);

    const description = useMemo(() => {
        if (allFields && allFields?.highlighter?.length > 0) {
            const descriptionData = allFields?.highlighter?.find(item => item.fieldName === accessor)?.description;
            return descriptionData;
        } else {
            return null;
        }
        // eslint-disable-next-line
    }, [allFields]);

    const handleAutoFillOpen = (event) => {
        setAutoFillAnchorEl(event.currentTarget);
    };

    const handleAutoFillClose = () => {
        setAutoFillAnchorEl(null);
    };

    const isAutoFillPopoverOpen = Boolean(autoFillAnchorEl);

    return (
        <Stack direction="row" alignItems={"center"} display={"flex"}>
            <Stack>
                <IconButton onClick={() => handleAddHighlight(accessor)} size="small">
                    <BorderColorIcon sx={{ fontSize: "14px" }} />
                </IconButton>
            </Stack>
            <Stack sx={{ marginTop: "7px" }}>
                {children}
            </Stack>
            {!!description && (
                <Stack key={description + accessor + "stack"}>
                    <Tooltip title={description} arrow placement="right" key={description + accessor + "tooltip"}>
                        <IconButton size="small" key={description + accessor}>
                            <DescriptionIcon sx={{ fontSize: "14px" }} />
                        </IconButton>
                    </Tooltip>
                </Stack>
            )}
            {autoFillEnabled && (
                <Stack key={accessor + "autofill-stack"}>
                    <Tooltip title="Auto Fill Enabled" arrow placement="right">
                        <IconButton size="small" onClick={handleAutoFillOpen}>
                            <AutoFixNormalIcon sx={{ fontSize: "14px" }} />
                        </IconButton>
                    </Tooltip>
                    <Popover
                        open={isAutoFillPopoverOpen}
                        anchorEl={autoFillAnchorEl}
                        onClose={handleAutoFillClose}
                        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                    >
                        <Box sx={{ p: 1.25, maxWidth: 320 }}>
                            <Typography sx={{ fontSize: '12px', fontFamily: 'mont reg' }}>
                                {autoFillInfo?.sourceLine || "Prior Admission"}
                            </Typography>
                            {(autoFillInfo?.label || autoFillInfo?.value) && (
                                <Box sx={{ mt: 0.5 }}>
                                    <Typography sx={{ fontSize: '12px', fontFamily: 'mont reg', color: '#5f6368' }}>
                                        Source: {autoFillInfo?.label || "Source"}
                                    </Typography>
                                    {autoFillInfo?.value && (
                                        <Typography sx={{ fontSize: '12px', fontFamily: 'mont reg', color: '#5f6368' }}>
                                            Value: {autoFillInfo.value}
                                        </Typography>
                                    )}
                                </Box>
                            )}
                        </Box>
                    </Popover>
                </Stack>
            )}
            {aiEnabled && (
                <Stack key={accessor + "ai-stack"}>
                    <Tooltip title="AI Enabled" arrow placement="right" key={accessor + "ai-tooltip"}>
                        <IconButton size="small" key={accessor + "ai"}>
                            <AIIcon sx={{ fontSize: "14px", color: "#4caf50", opacity: 0.8 }} />
                        </IconButton>
                    </Tooltip>
                </Stack>
            )}
        </Stack>
    )

}

export default QuestionLabel;
